<template>
  <v-dialog
      transition="dialog-bottom-transition"
      width="40%"
      v-model="dialog">

    <template v-slot:activator="{ props }">
      <v-btn
          data-automationId="newWorkshopButton"
          class="newWorkshopButton"
          color="primary"
          v-bind="props"
          @click="dialog = true;"
      ><v-icon icon="mdi-pen" color="white"></v-icon></v-btn>
    </template>
    <template v-slot:default>
      <v-card>
        <v-toolbar
            color="primary"
            title="Create a new Workshop"
        ></v-toolbar>
        <v-text-field data-automationId="newWorkshopName" type="text" label="Title" v-model="name"></v-text-field>
        <v-card-actions class="justify-end">
          <v-btn
              data-automationId="newWorkshopCreateButton"
              variant="text"
              @click="createWorkshop();"
          >Create Workshop</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import {createWorkshop} from "@/workshop/workshopFunctions";

export default {
  name: "NewWorkshopPopup",
  data() {
    return {
      name: '',
      dialog: false
    }
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    customerName: {
      type: String,
      required: true
    }
  },
  methods: {
    createWorkshop(){
      createWorkshop(this.$props.customerId, this.customerName, this.name).then(() => {
        this.dialog = false;
        this.$emit('WorkshopCreated');
      });
    }
  }
}
</script>

<style scoped>
  .newWorkshopButton{
    border-radius: 100%;
    width: 50px;
    height: 50px;
    float: right;
  }
</style>